import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';
import { ICodeDescription, IRecord } from '../../../../../type_definitions/datatypes';

export interface IAccreditation extends IRecord, ICodeDescription {}

export interface IBPProfileAccreditation extends IRecord {
  accreditation?:IAccreditation;
  comment?:string;
  active?:boolean; // covered
}

@Injectable()
export class BPProfilesAccreditationsDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getVendorAccreditations(vendorId:number, bpProfileId:number, type:string):Promise<IAccreditation[]> {
    return this.cache.doGET(
      `rest/bpprofiles/accreditations/${vendorId}`,
      { bpProfileId, type },
      undefined,
      'Error loading vendor accreditations'
    );
  }

  public updateAccreditation(bpProfileId:number, accreditationId:number, accreditation:IBPProfileAccreditation):Promise<IBPProfileAccreditation> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${bpProfileId}/accreditation/${accreditationId}`,
      undefined,
      accreditation,
      undefined,
      'Error updating accreditation'
    );
  }

  public saveAccreditations(bpProfileId:number, vendorId:number, accreditations:IBPProfileAccreditation[]):Promise<IBPProfileAccreditation> {
    return this.httpDataService.doPOST(
      `rest/bpprofiles/profiles/${bpProfileId}/accreditations`,
      { vendorId },
      accreditations,
      undefined,
      'Error saving accreditations'
    );
  }
}